import React from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';

const ComplaintCategoryField = ({ source, record = {} }) => {
    const translate = useTranslate();
    return (
        <span>{ translate(`resources.complaints.categories.${record[source]}`) } </span>
      );
};

ComplaintCategoryField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default ComplaintCategoryField;
